import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { TeamSection } from "@/components/sections/TeamSection";
import { CTASection } from "@/components/sections/CTASection";

const Team = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <TeamSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Team;
